import {NgModule} from '@angular/core';
import {Routes, RouterModule, NoPreloading} from '@angular/router';
import { ConfirmMailComponent } from './confirm-mail/confirm-mail.component';
import { HomeModule } from './home/home.module';
import { ReinitPasswordComponent } from './reinit-password/reinit-password.component';
import { AuthComponent } from './auth/auth.component';

const routes: Routes = [

    {
      path: '',
      loadChildren: () => HomeModule,
    },

    {
      path: 'authentication',
      component: AuthComponent,
    },

    {
      path: 'confirm-mail',
      component: ConfirmMailComponent,
    },

    {
      path: 'reinit-password',
      component: ReinitPasswordComponent,
    },

    {
      path: '**',
      redirectTo: 'not-found',
    }    

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}